@if (isAssetIcon()) {
  <span
    class="sidebar-asset-icon"
    [style.--sidebar-icon-source]="assetIconSource()"
    [attr.aria-hidden]="decorative() ? 'true' : null"
    [attr.aria-label]="!decorative() ? ariaLabel() : null"
    role="img"
  ></span>
} @else {
  <svg
    class="sidebar-inline-icon"
    [attr.viewBox]="iconDefinition().viewBox"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    [attr.aria-hidden]="decorative() ? 'true' : null"
    [attr.aria-label]="!decorative() ? ariaLabel() : null"
    role="img"
    [innerHTML]="iconMarkup()"
  ></svg>
}
